import { configureStore, type ThunkAction, type Action } from '@reduxjs/toolkit';
import applicantsSlice from './applicantsSlice';
import commonSlice from './commonSlice';

export const store = configureStore({
  reducer: {
    common: commonSlice,
    applicants: applicantsSlice,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
